import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useAppDispatch } from "src/hooks/redux";
import { addEmployee } from "src/store/reducers/employeesSlice";
import { closeModal, showModal } from "src/store/reducers/modalSlice";

import { PasswordInput } from "../../components";

export const CreatePasswordEmployeeScreen = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onPasswordInputValidate = (password: string) => {
    if (password.length < 8) {
      return "The value is not a valid password";
    }
    return "";
  };

  const onPasswordInputReValidate = (rePassword: string) => {
    if (rePassword.length < 8) {
      return "The value is not a valid password";
    }
    return "";
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const password = data.get("password");
    const repeatPassword = data.get("re-password");

    const path = new URLSearchParams(window.location.search);
    const token = path.get("token");

    if (
      !onPasswordInputValidate(password as string) &&
      !onPasswordInputReValidate(repeatPassword as string) &&
      password === repeatPassword
    ) {
      dispatch(
        addEmployee({
          token,
          password: repeatPassword,
          onSuccess: () => {
            navigate("*");
          },
          onFailure: (error: any) => {
            dispatch(
              showModal({
                modalType: "DELETE",
                title: `${error?.response?.data?.detail || error.message}`,
                okButtonTitle: "Ok, I got it",
                isButtonCancel: true,
                onButtonClick: () => {
                  dispatch(closeModal());
                },
              })
            );
          },
        })
      );
    }
  };

  return (
    <Box display="flex">
      <Box
        sx={{
          borderRadius: 4,
          paddingX: 4,
          maxWidth: 494,
          backgroundColor: "white",
        }}
      >
        <Box
          sx={{
            marginTop: "40px",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              position: "relative",
              justifyContent: "center",
              flexDirection: "column",
              flex: 1,
            }}
          >
            <Box
              sx={{
                mb: 4,
              }}
            >
              <img alt="Logo" width="40px" src="/images/logo.png" />
            </Box>
          </Box>
          <Box
            sx={{
              mb: "24px",
            }}
          >
            <Typography component="h1" variant="h2">
              Create password
            </Typography>
            <Typography
              sx={{
                color: "#363636",
                fontSize: "16px",
                fontWeight: "400",
                marginTop: "40px",
                textAlign: "left",
              }}
            >
              Please enter a password below
            </Typography>
          </Box>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <PasswordInput
              id="password-input"
              label="Password"
              name="password"
              initialValue=""
              validationFn={onPasswordInputValidate}
            />
            <PasswordInput
              id="re-password-input"
              label="Re-enter new password"
              name="re-password"
              initialValue=""
              validationFn={onPasswordInputReValidate}
            />
            <Button
              type="submit"
              fullWidth
              size="large"
              disableRipple
              disableElevation
              variant="contained"
              sx={{ mt: 3, mb: 4 }}
            >
              Create password
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
